import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';

import { GoogleAnalyticsService } from '@app/services/_index';
import { HasAnalytics } from '@app/interfaces/_index';
import { NguCarouselConfig } from '@ngu/carousel';
import { Video } from '@app/models/_index';
import { logGoogleAnalytics } from '@app/utilities/_index';

@Component({
  selector: 'app-video-slider',
  templateUrl: './video-slider.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./video-slider.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class VideoSliderComponent implements OnInit, HasAnalytics {
  carouselTile: NguCarouselConfig;

  @Input()
  videoArray: Video[] = [];

  @Input() carouselDotActiveCSS = 'default-active'; // Set background color for carousel dots

  constructor(
    private cdRef: ChangeDetectorRef,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
    this.carouselTile = {
      grid: { xs: 1, sm: 2, md: 3, lg: 3, all: 0 }, // XS shows 1 slide, SM shows 2 slides, M and greater show 3
      slide: 3,
      speed: 400,
      animation: 'lazy',
      point: { visible: false },
      load: 3,
      touch: true,
      easing: 'ease',
    };
  }

  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * Send the query search label to Google Analytics
   * @param category - the source of the google analytics category string (ex. the page or component triggering the action)
   * @param action - the action to be (ex. click)
   * @param dataLabel - the label associated with the action
   */
  sendGoogleAnalytics(category: string, action: string, dataLabel: string): void {
    logGoogleAnalytics(category, action, dataLabel);
    this.googleAnalyticsService.sendEvent(category, action, dataLabel);
  }

  /**
   * Add Track By Video Item Id to not redraw or re-render list items that have not changed.
   * This improves performance.
   * @param index - Index of Video item array
   * @param item - Video item
   * @returns Video item id
   */
  trackByVideoItemId(index: number, item: Video): string {
    if (item) {
      return item.id;
    } else {
      return String(index);
    }
  }
}
